//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Input text placeholder
     */
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * Input text label
     */
    label: {
      type: String,
      default: null
    },
    /**
     * Input text id
     */
    id: {
      type: String,
      default: ''
    },
    /**
     * Input text value
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * Input text type
     */
    type: {
      type: String,
      default: 'text'
    },
    /**
     * Whether the input text is required
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * Input text validation:
     * null: Input has not been validated yet
     * false: Input is valid
     * true: Input is invalid
     */
    isInvalid: {
      type: Boolean,
      default: null
    },
    /**
     * Whether input has an outline-border
     */
    outlineBorder: {
      type: Boolean,
      default: false
    },
    /**
     * Whether input has an outline-border and grey background
     */
    outlineBorderWithBackground: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cssClasses () {
      return ['base-input-text', {
        'base-input-text--outline-border': this.outlineBorder,
        'base-input-text--outline-border-background': this.outlineBorderWithBackground
      }]
    },
    textLabel () {
      return `${this.label}${this.required ? '*' : ''}`
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
